import { render, staticRenderFns } from "./form-question.vue?vue&type=template&id=dc0bd936"
import script from "./form-question.vue?vue&type=script&lang=js"
export * from "./form-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports